<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Daftar Penjadwalan</h5>
              <form class="d-flex gap-1">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <ul class="nav gap-1 mb-4">
              <li class="nav-item">
                <button
                  class="btn btn btn-success"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  @click="add()"
                >Buat Jadwal</button>
              </li>
            </ul>

            <div class="table-responsive">
              <table class="table align-middle table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th class="text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Penerima / Responden
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-nowrap w-50" scope="col">
                      <a href="#" class="link-dark">
                        Agenda & Lokasi
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Klasifikasi
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Tanggal
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Terkonfirmasi
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Status
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-end" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="dataList.length == 0">
                    <td colspan="12" align="center">There is no data for this page</td>
                  </tr>
                  <template v-if="dataList.length > 0">
                    <tr v-for="(req, idx) in dataList" :key="idx">
                      <th scope="row">{{ idx + 1 }}</th>
                      <td class="text-nowrap">{{ safeGet(req, 'user.user_profile.fullname') }}</td>
                      <td>
                        {{ req.title || '-' }}
                        <div class="small text-dark">Lokasi : {{ req.location || '-' }}</div>
                      </td>
                      <td class="text-center">{{ req.type || '-' }}</td>
                      <td class="text-center">
                        {{ formatDateHour(req.datetime) }}
                        <!-- <div class="small">(20:30 - 22:45)</div> -->
                      </td>
                      <td class="text-center">
                        <small
                          :class="req.is_attend == 1 ? 'text-bg-primary' : 'text-bg-dark'"
                          class="badge fs-1 bg-opacity-75"
                        >{{ req.is_attend == 1 ? 'Ya' : 'Tidak' }}</small>
                      </td>

                      <td class="text-center">
                        <small
                          :class="req.statusId == 7 ? 'text-bg-success' : 'text-bg-dark'"
                          class="badge fs-1 bg-opacity-75"
                        >{{ safeGet(req, 'site_status.status_name') }}</small>
                      </td>
                      <td class="text-nowrap text-end">
                        <!-- <a
                        class="btn btn-sm btn-outline-primary"
                        @click="edit(req.id)"
                        title="Edit"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        role="button"
                      >
                        <i class="ti ti-edit fs-3"></i>
                        </a>-->
                        <a
                          href="#"
                          class="btn btn-sm btn-outline-danger liveToastBtn"
                          title="Hapus"
                          @click="deleteData(req.id)"
                        >
                          <i class="ti ti-trash fs-3"></i>
                        </a>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="countDataList"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <form @submit.prevent="onSubmit">
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="modalNewExaminationlLabel">{{formTitle}} Jadwal</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-4">
                <label for class="form-label">Klasifikasi *</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.klasifikasi"
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      value="Umum"
                      autocomplete="off"
                      required
                    >
                    <label class="form-check-label" for="inlineRadio1">Umum</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.klasifikasi"
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="Personal"
                      autocomplete="off"
                    >
                    <label class="form-check-label" for="inlineRadio2">Personal</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.klasifikasi"
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio6"
                      value="Usia Kehamilan"
                      autocomplete="off"
                    >
                    <label class="form-check-label" for="inlineRadio6">Usia Kehamilan</label>
                  </div>
                </div>
              </div>

              <div v-if="form.klasifikasi == 'Personal'" class="mb-4">
                <label for class="form-label">Penerima / Responden *</label>
                <v-select
                  v-model="userID"
                  multiple
                  :placeholder="`-- Pilih --`"
                  label="label"
                  :options="userList.Records.map(elem => ({label: `${elem.user_profile.fullname} - ${elem.user_profile.nik}`, code: elem.id}))"
                />
                <!-- <select
                  v-model="form.responden"
                  class="form-select mb-1"
                  id="floatingSelect"
                  multiple
                  autocomplete="off"
                  required
                >
                  <option
                    v-for="item in userList.Records"
                    :value="item.id"
                    :key="`ul${item.id}`"
                  >{{item.user_profile.fullname}} - {{item.user_profile.nik || item.user_profile.telp}}</option>
                </select>-->
                <!-- <small
                  class="fst-italic"
                >** Tekan & tahan tombol CTRL/Command untuk pilih lebih dari satu.</small> -->
              </div>

              <div v-if="form.klasifikasi == 'Usia Kehamilan'" class="mb-4">
                <label for class="form-label">Usia Kehamilan *</label>
                <select
                  v-model="form.pregnancy_age"
                  class="form-select mb-1"
                  id="floatingSelect"
                  multiple
                  autocomplete="off"
                  required
                >
                  <!-- <?php for($i=1;$i<=28;$i++) { ?>
                  <option value="1"><?php print $i; ?> Minggu</option><?php } ?>-->
                  <option v-for="n in 28" :value="n" :key="`sp${n}`">{{ n }} minggu</option>
                </select>
                <small
                  class="fst-italic"
                >** Tekan & tahan tombol CTRL/Command untuk pilih lebih dari satu.</small>
              </div>

              <div class="mb-4">
                <label for class="form-label">Judul *</label>
                <input
                  v-model="form.title"
                  type="text"
                  class="form-control"
                  placeholder="Judul..."
                  autocomplete="off"
                  required
                >
              </div>

              <div class="mb-4">
                <label for class="form-label">Deskripsi *</label>
                <textarea
                  v-model="form.description"
                  class="form-control"
                  placeholder="Deskripsi..."
                  rows="3"
                  required
                ></textarea>
              </div>

              <div class="mb-4">
                <label for class="form-label">Alamat Lokasi *</label>
                <input
                  v-model="form.location"
                  type="text"
                  class="form-control"
                  placeholder="Lokasi..."
                  autocomplete="off"
                  required
                >
              </div>

              <div class="mb-4">
                <label for class="form-label">Tanggal *</label>
                <div class="d-flex gap-2 align-items-center">
                  <input
                    v-model="form.datetime"
                    type="datetime-local"
                    class="form-control"
                    placeholder="Tanggal..."
                    autocomplete="off"
                    required
                  >
                  <!-- :
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="00"
                      min="00"
                      max="60"
                      autocomplete="off"
                    >
                    <input
                      type="text"
                      class="form-control"
                      placeholder="00"
                      min="00"
                      max="60"
                      autocomplete="off"
                    >
                  </div>-
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="00"
                      min="00"
                      max="60"
                      autocomplete="off"
                    >
                    <input
                      type="text"
                      class="form-control"
                      placeholder="00"
                      min="00"
                      max="60"
                      autocomplete="off"
                    >
                  </div>-->
                </div>
              </div>

              <div class="mb-4">
                <label for class="form-label">URL Map</label>
                <input
                  v-model="form.url"
                  type="url"
                  class="form-control"
                  placeholder="https://..."
                  autocomplete="off"
                >
              </div>

              <div>
                <label for class="form-label">Status *</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.statusId"
                      class="form-check-input"
                      type="radio"
                      name="statusId"
                      id="inlineRadio11"
                      value="1"
                      autocomplete="off"
                      required
                    >
                    <label class="form-check-label" for="inlineRadio11">Aktif</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.statusId"
                      class="form-check-input"
                      type="radio"
                      name="statusId"
                      id="inlineRadio21"
                      value="2"
                      autocomplete="off"
                    >
                    <label class="form-check-label" for="inlineRadio21">Non-Aktif</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-dark" data-bs-dismiss="modal">Batal</button>
              <button type="submit" class="btn btn-success">Simpan</button>
              <!-- liveToastBtn -->
            </div>
          </div>
        </div>
      </div>
    </form>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import { allMixin } from '@/mixins/allMixin.js'

export default {
	mixins: [allMixin],
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			userID: [],
			form: {
				id: '',
				title: '',
				description: '',
				datetime: '',
				location: '',
				url: '',
				klasifikasi: 'Umum',
				responden: [],
				pregnancy_age: [],
				statusId: '1'
			},
			formTitle: 'Buat',
			url: 'user_schedules/create',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		this.$store.dispatch('location/getDataThird', {
			url: `users`,
			params: {
				type: 'patient',
				offset: 0,
				limit: 10000,
				order: 'desc'
			}
		})
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDataPayload',
			countDataList: 'location/getcountDataPayload',
			userList: 'location/getDataThird'
		}),
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		},
		pregnancy_age() {
			return this.form.pregnancy_age.join(',')
		},
		responden() {
			return this.userID.map((u) => u.code).join(',')
		}
		// responden() {
		// 	return this.form.responden.join(',')
		// }
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getDataPayload', {
					url: `user_schedules`,
					params: {
						userId: this.userId,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		onSubmit() {
			if (this.file) {
				let formData = new FormData()
				formData.append('upload', this.file)
				this.$store.dispatch('ticket/upload', formData).then((res) => {
					this.storeData(res.images)
				})
			} else {
				this.storeData('')
			}
		},
		storeData(attachment) {
			this.form.attachment = attachment

			this.form.pregnancy_age = this.pregnancy_age
			this.form.responden = this.responden
			this.form.datetime = this.localToUtcSameTime(this.form.datetime)
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: this.url,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
						document.querySelector('#exampleModal [data-bs-dismiss="modal"]').click()
						this.userID = []
						this.form = {
							id: '',
							title: '',
							description: '',
							datetime: '',
							location: '',
							url: '',
							klasifikasi: 'Umum',
							responden: [],
							pregnancy_age: [],
							statusId: '1'
						}
					} else {
					}
				})
		},
		deleteData(id) {
			var conf = confirm('Kamu akan menghapus rekaman ini. Apa kamu yakin?')
			if (conf === false) {
				return
			}
			this.$store
				.dispatch('location/createNewRecord', {
					url: 'user_schedules/' + id,
					method: 'DELETE'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
					} else {
					}
				})
		},
		edit(id) {
			let data = this.dataList.find((o) => o.id === id)
			console.log(data)
			this.form = {
				id: id,
				title: data.title,
				description: data.description,
				datetime: data.datetime,
				location: data.location,
				url: data.url,
				klasifikasi: data.type,
				type: data.type,
				doctorId: data.doctorId,
				pregnancyId: data.pregnancyId
			}
			this.formTitle = 'Edit'
			this.url = 'user_schedules/' + id
			this.method = 'put'
		},
		add() {
			this.form = {
				id: '',
				title: '',
				description: '',
				datetime: '',
				location: '',
				url: '',
				klasifikasi: 'Umum',
				responden: [],
				pregnancy_age: [],
				statusId: '1'
			}
			this.userID = []
			this.formTitle = 'Buat'
			this.url = 'user_schedules/create'
			this.method = 'post'
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
